import React, {
  ReactElement,
  SyntheticEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { Text, Flex } from 'rebass/styled-components';

import {
  AccountList as AccountListStyle,
  ProcedureList as ProcedureListStyle,
  ProcedureStyle,
} from './styles';
import { ProcedureSearch as SearchStyle } from '../styles';

import { Card, CardHeader, CardBody, Accordion } from 'ui/patterns';
import { Checkbox } from 'ui/components';

import * as Icon from 'assets/icons';
import NoDataImage from 'assets/images/NoDataImage';

import {
  SelectedAccounts,
  linkImportAccountList,
  ProcedureDetailsInList,
} from 'types/procedureBuilder';
import { AccountListType } from './linkProcedureTypes';

export default function AccountsList({
  procedureListData,
  checkedAccounts,
  setCheckedAccounts,
  onEndReached,
  setProcedureHeader,
  setKeywordSearch,
  keywordSearch,
  expanded,
  onClickExpanded,
  collapseAll,
  checkState,
  setCheckState,
}: AccountListType): ReactElement {
  const tbodyRef = useRef() as React.MutableRefObject<HTMLDivElement>;

  const [isAllSelected, setIsAllSelected] = useState(false);

  useEffect(() => {
    if (checkState) {
      setCheckState(false);
      handleSelectAllAccounts();
    }
  }, [procedureListData]);

  useEffect(() => {
    const state = isAllChecked();
    setIsAllSelected(state);
  }, [checkedAccounts]);

  //Procedure Selection
  const isProcedureChecked = (procedureId: number, accountId: number) => {
    const selectedAccount = checkedAccounts?.find(
      account => account.id === accountId,
    );
    const selectedProcedures = selectedAccount?.accountProcedures?.find(
      (procedure: { ProcedureId: number }) =>
        procedure.ProcedureId === procedureId,
    );

    if (selectedProcedures?.isChecked) {
      return true;
    } else return false;
  };

  const handleSelectedProcedure = (
    selectedProcedure: ProcedureDetailsInList,
    selectedAccount: linkImportAccountList,
  ) => {
    setProcedureHeader(false);
    const accountIndex =
      checkedAccounts && checkedAccounts.length > 0
        ? checkedAccounts?.findIndex(
            (account: { id: number }) =>
              account.id === selectedAccount.AccountId,
          )
        : -1;

    if (accountIndex === -1) {
      selectedAccount?.ProcedureDetails?.map((item: ProcedureDetailsInList) => {
        if (item.ProcedureId === selectedProcedure.ProcedureId) {
          item.isChecked = true;
        } else {
          item.isChecked = false;
        }
      });
      checkedAccounts &&
        checkedAccounts.push({
          id: selectedAccount.AccountId,
          name: selectedAccount.AccountName,
          accountProcedures: selectedAccount?.ProcedureDetails,
          accountNameAndNumber: selectedAccount?.AccountNameAndNumber,
          isAccountChecked: selectedAccount?.ProcedureDetails?.every(
            (x: ProcedureDetailsInList) => x?.isChecked === true,
          ),
          policiesSelected: true,
        });
    } else {
      checkedAccounts[accountIndex]?.accountProcedures?.forEach((item: any) => {
        if (item.ProcedureId === selectedProcedure.ProcedureId) {
          item.isChecked = !item.isChecked;
        }
      });
      let selectedProcedureCount = 0;
      checkedAccounts[accountIndex]?.accountProcedures?.forEach(
        (procedure: any) => {
          if (procedure.isChecked) {
            selectedProcedureCount += 1;
          }
        },
      );

      checkedAccounts[accountIndex] = {
        id: checkedAccounts[accountIndex].id,
        name: checkedAccounts[accountIndex].name,
        accountProcedures: checkedAccounts[accountIndex]?.accountProcedures,
        accountNameAndNumber:
          checkedAccounts[accountIndex]?.accountNameAndNumber,
        isAccountChecked: checkedAccounts[
          accountIndex
        ]?.accountProcedures?.every((x: any) => x.isChecked === true),
        policiesSelected: selectedProcedureCount ? true : false,
      };
    }

    const state = checkedAccounts[accountIndex]?.accountProcedures?.filter(
      (x: any) => x.isChecked === true,
    );

    if (
      state?.length !== checkedAccounts[accountIndex]?.accountProcedures?.length
    ) {
      setCheckState(false);
    }
    if (checkedAccounts) setCheckedAccounts([...checkedAccounts]);
  };
  //Procedure Selection

  //Account Selection
  const isAccountChecked = (item: linkImportAccountList) => {
    const selectedAccounts =
      checkedAccounts &&
      checkedAccounts?.length > 0 &&
      checkedAccounts?.find((account: SelectedAccounts) => {
        if (account.id === item.AccountId) {
          if (account.isAccountChecked === true) return account;
        }
      });

    if (selectedAccounts) {
      return true;
    } else {
      return false;
    }
  };

  const handleSelectedAccounts = (item: linkImportAccountList) => {
    setProcedureHeader(false);
    const index =
      checkedAccounts && checkedAccounts.length > 0
        ? checkedAccounts.findIndex(
            (account: { id: number }) => account.id === item.AccountId,
          )
        : -1;
    if (index === -1) {
      const procedures = item?.ProcedureDetails?.map(
        (element: ProcedureDetailsInList) => {
          return {
            ...element,
            isChecked: true,
          };
        },
      );
      checkedAccounts &&
        checkedAccounts.push({
          id: item.AccountId,
          name: item.AccountName,
          accountProcedures: procedures,
          accountNameAndNumber: item.AccountNameAndNumber,
          isAccountChecked: true,
          policiesSelected: true,
        });
      if (checkedAccounts.length === procedureListData.length) {
        setCheckState(true);
      }
    } else if (index >= 0) {
      setCheckState(false);
      checkedAccounts &&
        checkedAccounts.map((account: SelectedAccounts) => {
          if (account.id === item.AccountId) {
            account.isAccountChecked = !account.isAccountChecked;
            account.policiesSelected = account.isAccountChecked;
          }
          account?.accountProcedures?.map((element: any) => {
            if (item.AccountId === account.id) {
              element.isChecked = account.isAccountChecked;
            }
          });
        });
    }

    if (checkedAccounts) setCheckedAccounts([...checkedAccounts]);
  };
  //Account Selection

  //Select All //
  const isAllChecked = () => {
    const selectedData = checkedAccounts?.filter(
      (x: SelectedAccounts) => x.isAccountChecked === true,
    );
    if (
      selectedData?.length ===
      (procedureListData && procedureListData.length > 0
        ? procedureListData.length
        : null)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleSelectAllAccounts = () => {
    setProcedureHeader(false);
    let allDatas: SelectedAccounts[] = [];
    const isSelect = isAllChecked();
    if (!isSelect) {
      allDatas =
        procedureListData && procedureListData.length > 0
          ? procedureListData.map(procedure => {
              procedure?.ProcedureDetails?.map(
                (procedureDetailData: ProcedureDetailsInList) =>
                  (procedureDetailData.isChecked = true),
              );
              return {
                id: procedure.AccountId,
                name: procedure.AccountName,
                accountProcedures: procedure.ProcedureDetails,
                accountNameAndNumber: procedure.AccountNameAndNumber,
                isAccountChecked: true,
                policiesSelected: true,
              };
            })
          : [];
      setCheckState(true);
    } else {
      allDatas = [];
      setCheckState(false);
    }
    setCheckedAccounts([...allDatas]);
  };
  //Select All //

  const handleKeywordSearch = (e: SyntheticEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    setKeywordSearch(value);
    collapseAll();
  };

  const handleScroll = useCallback(
    (e: any) => {
      if (tbodyRef.current === e.target) {
        const bottom =
          e.target.clientHeight - 10 <
            e.target.scrollHeight - e.target.scrollTop &&
          e.target.scrollHeight - e.target.scrollTop <
            e.target.clientHeight + 10;
        if (bottom) {
          onEndReached && onEndReached();
        }
      }
    },
    [onEndReached, tbodyRef],
  );

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, [handleScroll]);

  const isAnyProcedureChecked = (accountId: number) => {
    const indeterminedAccounts = checkedAccounts.find(accounts => {
      if (accounts.id === accountId) {
        if (
          accounts.policiesSelected === true &&
          accounts.isAccountChecked === false
        ) {
          return accounts;
        }
      }
    });
    if (indeterminedAccounts) {
      return true;
    } else return false;
  };

  const handleProcedureHeaderClick = (
    selectedProcedure: ProcedureDetailsInList,
    selectedAccount: linkImportAccountList,
  ) => {
    setProcedureHeader(true);
    const accountIndex =
      checkedAccounts && checkedAccounts.length > 0
        ? checkedAccounts?.findIndex(
            (account: { id: number }) =>
              account.id === selectedAccount.AccountId,
          )
        : -1;
    if (accountIndex === -1) {
      selectedAccount?.ProcedureDetails?.map(item => {
        if (item.ProcedureId === selectedProcedure.ProcedureId) {
          item.isChecked = true;
        } else item.isChecked = false;
      });
      checkedAccounts &&
        checkedAccounts.push({
          id: selectedAccount.AccountId,
          name: selectedAccount.AccountName,
          accountProcedures: selectedAccount?.ProcedureDetails,
          accountNameAndNumber: selectedAccount?.AccountNameAndNumber,
          isAccountChecked: selectedAccount?.ProcedureDetails?.every(
            x => x.isChecked === true,
          ),
          policiesSelected: true,
        });
      checkedAccounts?.map(accounts =>
        accounts?.accountProcedures?.map((procedure: any) => {
          if (accounts.id !== selectedAccount.AccountId) {
            procedure.isChecked = false;
            accounts.isAccountChecked = false;
            accounts.policiesSelected = false;
          }
        }),
      );
    } else {
      checkedAccounts?.map(accounts =>
        accounts?.accountProcedures?.map((procedure: any) => {
          if (procedure.ProcedureId === selectedProcedure.ProcedureId) {
            procedure.isChecked = true;
            accounts.policiesSelected = true;
            accounts.isAccountChecked =
              selectedAccount?.ProcedureDetails?.length === 1 ? true : false;
          } else {
            if (selectedAccount.AccountId !== accounts.id) {
              accounts.policiesSelected = false;
            }
            procedure.isChecked = false;
            accounts.isAccountChecked = false;
          }
        }),
      );
    }
    setCheckedAccounts([...checkedAccounts]);
  };

  return (
    <Card width="345px" flexDirection="column" style={{ display: 'flex' }}>
      <CardHeader
        p={3}
        bg="var(--color-neutral-contrast-01)"
        alignItems="center"
        style={{ display: 'flex' }}
      >
        <Text as="h4" fontWeight="medium" lineHeight={1} color="text.body">
          Accounts
        </Text>
      </CardHeader>
      <SearchStyle>
        <Checkbox
          label=" "
          key="selectAll"
          name="selectAllLinkProcedures"
          checked={isAllSelected}
          handleChange={() => {
            handleSelectAllAccounts();
          }}
        />
        <div className="search-input">
          <Icon.Search />
          <input
            type="search"
            placeholder="Search account name or CID"
            value={keywordSearch}
            onChange={(e: SyntheticEvent<HTMLInputElement>) =>
              handleKeywordSearch(e)
            }
          />
        </div>
      </SearchStyle>
      <CardBody
        flex="1 0 auto"
        overflowY="auto"
        overflowX="hidden"
        height="1px"
        ref={tbodyRef}
      >
        <AccountListStyle>
          {procedureListData &&
            procedureListData.length > 0 &&
            procedureListData.map((accounts, accountIndex) => (
              <Accordion
                key={`AccountsList-Accordion-${accounts.AccountNameAndNumber}`}
                toggleButtonVariant="subtle"
                className="pb-link-listitem"
                opened={expanded && expanded[accountIndex]}
                setExpanded={(opened: boolean) =>
                  onClickExpanded(accountIndex, opened)
                }
                headerContent={
                  <Checkbox
                    label={accounts.AccountNameAndNumber}
                    title={accounts.AccountNameAndNumber}
                    name={`${accounts.AccountNameAndNumber} - ${accounts.AccountName}`}
                    className="pb-cb__link-account"
                    checked={isAccountChecked(accounts)}
                    indeterminate={isAnyProcedureChecked(accounts.AccountId)}
                    handleChange={() => {
                      handleSelectedAccounts(accounts);
                    }}
                  />
                }
              >
                <ProcedureListStyle>
                  {accounts && accounts.ProcedureDetails
                    ? accounts.ProcedureDetails?.map(
                        (accountProcedures: any, procedureIndex: any) => (
                          <ProcedureStyle key={procedureIndex}>
                            <Checkbox
                              key={procedureIndex}
                              label=""
                              title={
                                accounts.AccountId +
                                accountProcedures?.ProcedureName
                              }
                              name={
                                accounts.AccountId +
                                accountProcedures?.ProcedureId
                              }
                              handleChange={() =>
                                handleSelectedProcedure(
                                  accountProcedures,
                                  accounts,
                                )
                              }
                              checked={isProcedureChecked(
                                accountProcedures?.ProcedureId,
                                accounts.AccountId,
                              )}
                            />

                            <Text
                              className="truncate"
                              title={accountProcedures?.ProcedureName}
                              style={{
                                position: 'relative',
                                top: '-1px',
                                cursor: 'pointer',
                                flex: 1,
                              }}
                              onClick={() =>
                                handleProcedureHeaderClick(
                                  accountProcedures,
                                  accounts,
                                )
                              }
                            >
                              {accountProcedures?.ProcedureName}
                            </Text>
                            <Flex
                              alignItems="center"
                              justifyContent="center"
                              mx={2}
                            >
                              {accountProcedures?.IsVisible ? (
                                <Icon.Eye
                                  fill="var(--color-neutral-contrast-05)"
                                  title="Active"
                                />
                              ) : (
                                <Icon.EyeOff
                                  fill="var(--color-neutral-contrast-05)"
                                  title="Hidden"
                                />
                              )}
                            </Flex>
                          </ProcedureStyle>
                        ),
                      )
                    : ''}
                </ProcedureListStyle>
              </Accordion>
            ))}
        </AccountListStyle>
        {procedureListData && procedureListData.length <= 0 && (
          <NoDataImage height="100%" feedback="No data available" />
        )}
      </CardBody>
    </Card>
  );
}
